import { useEffect, useRef } from "react";

function useResizeObserver(otherProps = {}) {
  const currentRef = useRef();

  useEffect(() => {
    const sendDimensions = () => {
      if (!currentRef.current) return;
      if (window.parent) {
        const dimensions = currentRef.current.getBoundingClientRect();
        window.parent.postMessage(
          { type: "_COMPONENT_DIMENSIONS", dimensions, ...otherProps },
          "*",
        );
      }
    };

    // dispara no próximo tick para garantir que o ref esteja anexado
    const id = setTimeout(sendDimensions, 0);
    window.addEventListener("resize", sendDimensions);

    return () => {
      clearTimeout(id);
      window.removeEventListener("resize", sendDimensions);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return currentRef;
}

export default useResizeObserver;
